import {get} from 'lodash'
import {getAllRows} from 'selectors/pivotTable'
import {resourceModesTableKey} from 'reducers/pricingCalculator'

export const getCalculationResult = state => get(state, 'pricingCalculator.result', null)
export const isCalculating = state => get(state, 'pricingCalculator.isCalculating', false)
export const getLastExecution = state => get(state, 'pricingCalculator.lastExecution', null)
export const isSendingToSupport = state => get(state, 'pricingCalculator.isSendingToSupport', false)

export const getPartPricing = state =>
  get(state, 'pricingCalculator.partPricing', {})

export const getFieldMappings = state => get(state, 'pricingCalculator.fieldMappings', {})
export const getCalculatorEditableColumns = state => {
  const mappings = getFieldMappings(state)
  return [
    'department', 'desc', 'discount', 'nominalCode', 'notes', 'packType', 'partCode', 'scalingType',
    ...Object.values(mappings).flatMap(m => Object.values(m)),
    'markup', 'margin', 'unitPrice',
  ].filter((v, i, a) => a.indexOf(v) === i)
}

export const getPricingCalculatorInstance = state => get(state, 'pricingCalculator.calculatorInstance', null)

export const getFormDefinition = state => get(state, 'pricingCalculator.formDefinition', null)
export const getFormLoading = state => get(state, 'pricingCalculator.formLoading', false)
export const getFormError = state => get(state, 'pricingCalculator.formError', null)

export const getResourceTypes = state => get(state, 'pricingCalculator.resourceTypes', [])
export const getResources = state => get(state, 'pricingCalculator.resources', [])
export const isResourcesFormLoading = state => get(state, 'pricingCalculator.isResourcesFormLoading', false)

export const isIncludingDormantResources = (state, resourceType) =>
  get(state, ['pricingCalculator', 'includeDormantResources', resourceType], false)

const getSelectedResourceTypeName = (state) =>
  get(state, 'pricingCalculator.selectedResourceType', null)

export const getSelectedResourceType = (state) => {
  const resourceTypes = getResourceTypes(state)
  const selected = getSelectedResourceTypeName(state)
  return resourceTypes.find((resourceType) => resourceType.name === selected) || resourceTypes[0]
}

export const getResourceModes = state => getAllRows(state, resourceModesTableKey)

export const isSavingResource = state => get(state, 'pricingCalculator.isSavingResource', false)
export const getResourceSaveError = state => get(state, 'pricingCalculator.resourceSaveError', null)

export const isPricingCalculatorsLoading = state => get(state, 'settingsContext.pricingCalculators.loading', false)
export const getAllPricingCalculators = state => get(state, 'settingsContext.pricingCalculators.data', [])

export const isPricingCalculatorFormLoading = state =>
  get(state, 'settingsContext.pricingCalculators.loadingForm', false)
export const getPricingCalculatorForm = state =>
  get(state, 'settingsContext.pricingCalculators.form', null)

export const isPricingCalculatorMasterLoading = state =>
  get(state, 'settingsContext.pricingCalculators.loadingMaster', false)
export const getPricingCalculatorMaster = state => get(state, 'settingsContext.pricingCalculators.master', null)
